import React, { useMemo, useReducer } from 'react';
import { t } from 'i18next';
import { Accordion, AmountInput, ErrorBadge, ErrorLevel } from '@sovryn/ui';
import { translations } from '../../../locales/i18n';
export const AdvancedSettings = ({ amount, onChange, className, invalid, errorMessage, }) => {
    const [open, toggle] = useReducer(v => !v, false);
    const errorBadge = useMemo(() => {
        if (!invalid) {
            return null;
        }
        return React.createElement(ErrorBadge, { level: ErrorLevel.Critical, message: errorMessage });
    }, [invalid, errorMessage]);
    return (React.createElement(Accordion, { open: open, label: t(translations.advancedSettings.label), onClick: toggle, className: className, children: React.createElement(React.Fragment, null,
            React.createElement(AmountInput, { label: t(translations.advancedSettings.inputLabel), value: amount, onChangeText: onChange, invalid: invalid, unit: "%", className: "max-w-full", dataAttribute: "advanced-settings-input", decimalPrecision: 2 }),
            errorBadge), dataAttribute: "advanced-settings-accordion" }));
};
